import { AgentPreset } from "../model/types";

export const fetchAgentPresets = async (): Promise<AgentPreset[]> => {
  const response = await fetch("/api/agents", {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  return data;
};

/**
 * 에이전트 프리셋 조회 (인증 필요)
 * @param agentId 에이전트 ID
 * @returns AgentPreset
 */
export const fetchAgentPresetById = async (agentId: string): Promise<AgentPreset> => {
  const response = await fetch(`/api/agents/${agentId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  return data;
};

/**
 * 공개 에이전트 프리셋 조회 (인증 불필요)
 * 박람회/전시회 키오스크 환경에서 사용
 * @param agentId 에이전트 ID
 * @returns AgentPreset
 */
export const fetchPublicAgentPresetById = async (agentId: string): Promise<AgentPreset> => {
  const response = await fetch(`/api/public/agents/${agentId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  return data;
};